import { render, staticRenderFns } from "./InlineAlert.vue?vue&type=template&id=71b721fc&scoped=true"
import script from "./InlineAlert.vue?vue&type=script&lang=ts"
export * from "./InlineAlert.vue?vue&type=script&lang=ts"
import style0 from "./InlineAlert.vue?vue&type=style&index=0&id=71b721fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b721fc",
  null
  
)

export default component.exports